const IpAuthIntegrated = ({language , token}) => {
    const newIpAuthIframe = "https:" +
    window.process.env.URL_Boitier_Ip
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_ipAuth_display"
        src={newIpAuthIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default IpAuthIntegrated